import { z } from "zod";

/**
 * Schema for raw cube data response from the CSO or CSOTag cube.
 * Supports all three cost types (List, Billed, Effective).
 *
 * @param cube - The cube the stats were queried from
 */
export function costStatsRawDataSchema(cube: "CSO" | "CSOTag") {
  return z
    .array(
      z.object({
        [`${cube}.date.day`]: z.string(),
        [`${cube}.date`]: z.string(),
        [`${cube}.monthlyListSavingOpportunity`]: z.string().nullish(),
        [`${cube}.monthlyBilledSavingOpportunity`]: z.string().nullish(),
        [`${cube}.monthlyEffectiveSavingOpportunity`]: z.string().nullish(),
        [`${cube}.nonCompliantResourceCount`]: z.string(),
      }),
    )
    .nullish();
}
